import React from 'react';

import SelectItem from '../selects/SelectItem';
import SelectMaterial from './../selects/SelectMaterial';
import { colorStand } from '../../utils/colors';

export default class ModalCabinet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validFields: {
                width: false,
                height: false,
                depth: false,
                material: false,
                color: false,
                position: false,
                secondMaterial: false,
                secondColor: false,
            },
            options: {
                width: [],
                height: [],
                depth: [],
                material: [],
                color: [],
                position: [],
                secondMaterial: [],
                secondColor: [],
            },
            currentOptions: {
                width: '',
                height: '',
                depth: '',
                material: '',
                color: '',
                position: '',
                secondMaterial: '',
                secondColor: '',
            }
        }
    }

    componentDidMount() {
        this._initParameters(this.props.currentCabinetList);   
    }

    componentDidUpdate(prevProst, prevState) {
        if(JSON.stringify(prevState.currentOptions) !== JSON.stringify(this.state.currentOptions)) {
            if(!this.props.secondColor) {
                this.setSecondMaterialAndColor({value: null});
            }
            this._validateFields();
            const filterStands = this._searchCabinet();
            if(filterStands.length === 1 && this.state.currentOptions.material) {
                this.props.updatePrice(filterStands[0].material[this.state.currentOptions.material].price);
            }
        }
    }

    _validateFields() {
        const copyValidateObject = JSON.parse(JSON.stringify(this.state.validFields));
        const currentOptions = this.state.currentOptions;
        for(let key in currentOptions) {
            if(currentOptions[key]!=='') {
                copyValidateObject[key] = true;
            }
            else {
                copyValidateObject[key] = false;
            }
        }
        
        let checkAllValidate = true;

        for(let key in copyValidateObject) {
            if(copyValidateObject[key] === false) {
                checkAllValidate = false;
            }
        }

        if(checkAllValidate) this.props.updateValidate('cabinet', true);
        else this.props.updateValidate('cabinet', false);
        
        this.setState(state => {
            return {
                validFields: copyValidateObject
            }
        })
    }

    _fieldsManager() {
        const filterArray = this.props.currentCabinetList.filter(cabinet => {
            const checkWidth = cabinet.width === this.state.currentOptions.width || this.state.currentOptions.width === '' || this.state.currentOptions.width === undefined;
            const checkHeight = cabinet.height === this.state.currentOptions.height || this.state.currentOptions.height === '' || this.state.currentOptions.height === undefined;
            const checkDepth = cabinet.depth === this.state.currentOptions.depth || this.state.currentOptions.depth === '' || this.state.currentOptions.depth === undefined;
            return checkWidth && checkHeight && checkDepth;
        })
        this._initParameters(filterArray);
    }

    _initParameters(cabinets) {
        const uniqueHeights = [];
        const uniqueDepths = [];
        const uniqueWidths = [];
        cabinets.forEach(currentCabinet => {
            const uniqueWidth = uniqueWidths.find((width) => {
                return width.value === currentCabinet.width
            })

            const uniqueHeight = uniqueHeights.find((height) => {
                return height.value === currentCabinet.height
            })

            const uniqueDepth = uniqueDepths.find((depth) => {
                return depth.value === currentCabinet.depth
            })
            
            if(!uniqueHeight) {
                uniqueHeights.push(
                {
                    value: currentCabinet.height,
                    label: `${currentCabinet.height} мм`
                });
            }

            if(!uniqueDepth) {
                uniqueDepths.push(
                {
                    value: currentCabinet.depth,
                    label: `${currentCabinet.depth} мм`
                });
            }
            
            if(!uniqueWidth) {
                uniqueWidths.push(
                {
                    value: currentCabinet.width,
                    label: `${currentCabinet.width} мм`
                });
            }
        }); 
        const newOptions = {...this.state.options};
        newOptions.width = [...uniqueWidths];
        newOptions.height = [...uniqueHeights];
        newOptions.depth = [...uniqueDepths];
        newOptions.material = this._initMaterial(cabinets);
        newOptions.secondMaterial = this._initMaterial(cabinets);
        newOptions.position = [
            {
                value: 'L',
                label: 'Слева',
            },
            {
                value: 'R',
                label: 'Справа'
            }
        ]
        if(this.state.currentOptions.secondMaterial) {
            newOptions.secondColor = this._initColor(this.state.currentOptions.secondMaterial);
        }
        if(this.state.currentOptions.material) {
            newOptions.color = this._initColor(this.state.currentOptions.material);
        }

        
        this.setState((state) => {
            return {
                options: newOptions
            }
        })
    }

    _initColor(material) {
        let colors = [];
        let colorsOptions = []
        for(let key in colorStand) {
            if(key === material) {
                colors = colorStand[key][0].colors;
            }
        }
        colors.forEach(color => {
            colorsOptions.push({
                value: color.color,
                label: <div><span>{`${color.name}`}</span><img src={color.img}/></div>
            })
        })
        return colorsOptions;
    }


    _initMaterial(cabinets) {
        const materials = [];
        const cabinetItem = cabinets[0].material;
        for(let key in cabinetItem) {
            if(cabinetItem[key].price !== false && cabinetItem[key].price !== 0) {
                materials.push(key)
            }
        }
        const options = [];
        materials.forEach(material => {
            for(let key in colorStand) {
                if(key === material) {
                    options.push({
                        value: key,
                        label: <div><span>{`${colorStand[key][0].name}`}</span><img src={colorStand[key][0].img}/></div>
                    })
                }
            }
        })
        return options;
    }

    setWidth(value) {
        if(value || value === '') {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.width = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => this._fieldsManager())
        }
        
    }

    setHeight(value) {
        if(value || value === '') {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.height = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => this._fieldsManager())
        }
        
    }

    setDepth(value) {
        if(value || value === '') {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.depth = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => this._fieldsManager())
        }
        
    }

    setMaterial(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.material = value.value;
            options.color = '';
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => this._fieldsManager())
        }
    }
    

    setColor(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.color = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            })
        }
    }

    setPosition(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.position = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            })
        }
    }

    setSecondMaterial(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.secondMaterial = value.value;
            options.secondColor = '';
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => this._fieldsManager())
        }
    }

    setSecondColor(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.secondColor = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            })
        }
    }

    setSecondMaterialAndColor(value) {
        if(value) {
            const options = JSON.parse(JSON.stringify(this.state.currentOptions))
            options.secondMaterial = value.value;
            options.secondColor = value.value;
            this.setState(state => {
                return {
                    currentOptions: options
                }
            },
            () => this._fieldsManager())
        }
    }

    _searchCabinet() {
        const currentCabinet = this.props.currentCabinetList.filter(cabinet => {
            return cabinet.width === this.state.currentOptions.width && cabinet.height === this.state.currentOptions.height && cabinet.depth === this.state.currentOptions.depth
        })
        return currentCabinet;
    }

    setCabinet() {
        const cabinet = this._searchCabinet();
        const configurations = JSON.parse(JSON.stringify(this.props.srcConfig))
        configurations.cabinet = {
            color: this.state.currentOptions.color,
            material: this.state.currentOptions.material,
            secondMaterial: this.state.currentOptions.secondMaterial,
            secondColor: this.state.currentOptions.secondColor,
            article: cabinet[0].code,
            id: cabinet[0].fileName,
            position: this.state.currentOptions.position
        }
        this.props.setConfiguration(configurations);
    }


    render() {
        return (
            <>
                <div className='modal-window__controls'>
                    {window.innerWidth >= 1200  ? '' : <h2 className='modal-window__controls-title'>Выберите параметры:</h2>}
                    <div className='modal-window__control'>
                        <SelectItem handleChange = {this.setWidth.bind(this)} validate={this.props.validateParts ? this.state.validFields.width : true} options = {this.state.options.width} placeholder={'Ширина'}/>
                    </div>
                    <div className='modal-window__control'>
                        <SelectItem handleChange = {this.setHeight.bind(this)} validate={this.props.validateParts ?this.state.validFields.height : true} options = {this.state.options.height} placeholder={'Высота'}/>
                    </div>
                    <div className='modal-window__control'>
                        <SelectItem handleChange = {this.setDepth.bind(this)} validate={this.props.validateParts ? this.state.validFields.depth : true} options = {this.state.options.depth} placeholder={'Глубина'}/>
                    </div>
                </div>
                <div className='modal-window__controls'>
                    <div className='modal-window__control'>
                        <SelectItem handleChange = {this.setPosition.bind(this)} validate={this.props.validateParts ? this.state.validFields.position : true} options = {this.state.options.position} placeholder={'Расположение петель'}/>
                    </div>
                    <div className='modal-window__control '>
                        <SelectMaterial handleChange = {this.setMaterial.bind(this)} validate={this.props.validateParts ? this.state.validFields.material : true} options = {this.state.options.material} placeholder={'Материал'}/>
                    </div>
                    <div className={`modal-window__control ${this.state.currentOptions.material === '' ? 'modal-window__control--disabled' : ''} `}>
                        <SelectMaterial name ="color" handleChange = {this.setColor.bind(this)} validate={this.props.validateParts ? this.state.validFields.color : true} options = {this.state.options.color} placeholder={'Цвет'}/>
                    </div>
                    
                    
                </div>
                <div className='modal-window__controls'>
                    {
                        this.props.secondColor ? 
                        <>
                            <div className='modal-window__control '>
                                <SelectMaterial handleChange = {this.setSecondMaterial.bind(this)} validate={this.props.validateParts ? this.state.validFields.secondMaterial : true} options = {this.state.options.secondMaterial} placeholder={'Второй материал'}/>
                            </div>
                            <div className={`modal-window__control ${this.state.currentOptions.secondMaterial === '' ? 'modal-window__control--disabled' : ''} `}>
                                <SelectMaterial name ="color" handleChange = {this.setSecondColor.bind(this)} validate={this.props.validateParts ? this.state.validFields.secondColor : true} options = {this.state.options.secondColor} placeholder={'Второй цвет'}/>
                            </div>
                        </>
                        :
                        <></>
                    }
                </div>
                
            </>
            
        )
    }
}


